(function() {
    'use strict';

    angular.module( APP_ID )
        .factory( '_', [ '$window', LodashService ]);


    /**
     * Exposes lodash core to the app. See
     * (https://github.com/lodash/lodash/wiki/Build-Differences)
     *
     * @param {ng.IWindowService} $window
     *
     * @returns {Lodash}
     */
    function LodashService( $window ){



        ////////////////////////////////////////////////////////////////////

        return $window._; // Expose API

        ////////////////////////////////////////////////////////////////////

    }
})();
